import { render, staticRenderFns } from "./TabAnnexeCovid.vue?vue&type=template&id=c807e0d2&scoped=true"
import script from "./TabAnnexeCovid.vue?vue&type=script&lang=js"
export * from "./TabAnnexeCovid.vue?vue&type=script&lang=js"
import style0 from "./TabAnnexeCovid.vue?vue&type=style&index=0&id=c807e0d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c807e0d2",
  null
  
)

export default component.exports